export const DIALOGS_ALERT_CHECKTIME = {
	minWidth: "560px",
	buttonProps: {
		ok: {
			text: "Sí, marcar",
			width: "95px",
			size: "medium",
		},
		cancel: {
			variant: "secondary",
			text: "Cancelar",
			width: "95px",
			size: "medium",
		},
	},
};
export const INIT_INFO_TEACHER_ATTENDANCE = {
	// checkInTime: "16:14:32",
	// checkOutTime: "17:15:12",
	// classTime: "61 minutos"
	checkInTime: "",
	checkOutTime: "",
	classTime: "",
};
